module.exports = __webpack_public_path__ + "img/pix.334fa317.svg";